"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1758))
 * @lastsynced 2026-10-29T13:54:59.994Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Subtract = createSVGIcon(
  <path
    d="M2 12h20"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Subtract",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "HF+pg9",
      defaultMessage: "Subtract",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
